import styled from 'styled-components';

export const Container = styled.div``;

export const Div = styled.div``;

/** The design's `.tabs` — the card's top edge. */
export const Tabs = styled.div`
  display: flex;
  gap: var(--s5);
  padding: 0 var(--s5);
  border-bottom: 1px solid var(--line);

  a {
    display: block;
  }
`;

export const Tab = styled.button`
  padding: var(--s3) 0 10px;
  margin-bottom: -1px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  font-family: var(--font-ui);
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  color: var(--text-muted);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: var(--text);
  }

  &.active {
    color: var(--primary);
    border-bottom-color: var(--primary);
    font-weight: var(--fw-semibold);
  }
`;

export const TabPanel = styled.div``;

/** The panel's body — the design's `.card-body` inside a flush card. */
export const Body = styled.div`
  padding: var(--s5);
`;

/** The design's `.grid-2`. */
export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--s5);
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

/** Vertical rhythm between the fields in one column. */
export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/** The design's `.actionbar`, on the card's foot. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  padding: var(--s4) var(--s5);
  border-top: 1px solid var(--line);
  background: var(--surface-alt);
`;

/** The heading over the selected-people table. The design's `.subhead`. */
export const SubHead = styled.div`
  font-size: var(--fs-th);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-faint);
  margin-bottom: var(--s3);
`;
